import { memo } from 'react';
import { SingleToolHeader } from '@quicktools/shared-components';
import { useTranslation } from 'react-i18next';

import analytics from '../../services/analytics';

import useStyles from './styles';

function Header() {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <SingleToolHeader className={styles.root} toolName={t('toolName')} analytics={analytics} />
  );
}

export default memo(Header);
